import { render, staticRenderFns } from "./resizeHandle.vue?vue&type=template&id=85a3804e&"
import script from "./resizeHandle.vue?vue&type=script&lang=js&"
export * from "./resizeHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports